package com.wintermar.inspection.feature.presentation.inspection.answer.widget.choice_answer

import androidx.compose.ui.graphics.Color

data class ChoiceAnswerColorModel(
    val backgroundColor: Color,
    val borderColor: Color,
    val textColor: Color,
    val badgeColor: Color
)
